import 'core-js';

import initAdvertisementSystem from 'common/module/advertisement';
import initMqState from 'common/tools/dom/mq-state';
import { initialize as initializeRouter } from 'common/tools/network/routing';
import injectPolyfills from 'common/tools/polyfills';
import desobfuscation from 'common/tools/seo/desobfuscation';
import loadAssets from 'common/tools/ui/load-assets';
import loadFonts from 'common/tools/ui/load-fonts';

export default async function pageCommon() {
  await injectPolyfills();
  loadFonts();
  initMqState();
  loadAssets();
  desobfuscation();
  initAdvertisementSystem();
  initializeRouter(window.AC.routing);
}
